export default __webpack_public_path__ + "static/media/flag-fiji.bea208bb.svg";